import {
  GET_CAMPAIGN_HISTORICAL_SUCCESS,
  GET_CAMPAIGN_HISTORICAL_FAILURE
} from '../constants';
import axios from 'axios';

export const getCampaignHistoricalViews = campaignId => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firebase = getFirebase();
    return firebase
      .auth()
      .currentUser.getIdToken(false)
      .then(idToken => {
        return axios
          .post(
            `${process.env.REACT_APP_FIREBASE_URL}/getHistoricalCampaignStatistics`,
            {
              campaignId,
              idToken
            }
          )
          .then(response => {
            dispatch({
              type: GET_CAMPAIGN_HISTORICAL_SUCCESS,
              data: { stats: response.data, campaignId }
            });
          })
          .catch(err => {
            dispatch({ type: GET_CAMPAIGN_HISTORICAL_FAILURE, err });
          });
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/campaignStatisticsActions.js